<template>
  <div class="person-center">
    <h3>基本信息</h3>
    <a-divider />
    <div class="person-info">
      <div class="person-photo">
        <a-upload
          action="http://www.lexiangspace.com/api/sys/fs"
          listType="picture-card"
          :fileList="fileList"
          @preview="handlePreview"
          @change="handleChange"
        >
          <div v-if="fileList.length < 1">
            <a-icon type="plus" />
            <div class="ant-upload-text">上传头像</div>
          </div>
        </a-upload>
        <a-modal
          :visible="previewVisible"
          :footer="null"
          @cancel="handleCancel"
        >
          <img alt="example" style="width: 100%" :src="previewImage" />
        </a-modal>
      </div>
      <!-- <div class="person-info">
        <img :src="getPhoto(personInfo.headPic)" width="135px" />
      </div>-->
      <div class="person-detail">
        <p>
          {{ personInfo.nickname }}（{{
            personInfo.schoolType === "TEACHER" ? "教师" : "学生及家长"
          }}）
        </p>
        <p v-if="personInfo.schoolType === 'TEACHER'">职称：{{ personInfo.zc ? personInfo.zc : "---" }}</p>
        <p>{{personInfo.schoolType === 'TEACHER'?'教师工号':'学生编号'}}：{{ personInfo.no }}</p>
        <p>手机号码：{{ personInfo.phone }}</p>
        <!-- <span @click="phoneModal = true">修改手机号</span> -->

        <p>学校信息：{{ personInfo.schoolName }}
          <label v-if="personInfo.remark">（{{ personInfo.remark }}）</label>
        </p>
        <p v-if="personInfo.schoolType === 'STUDENT'">入学时间：{{personInfo.intoYear}}</p>
        <p v-if="personInfo.schoolType === 'STUDENT'">班级信息：{{personInfo.team}}</p>
        <p>
          <!-- 登录密码：{{personInfo.pwd ? '已设置': '未设置'}} -->
          <span @click="passwordModal = true">修改密码</span>
        </p>
      </div>
    </div>
    <div class="person-address">
      <div>邮寄地址</div>
      <a-button
        type="primary"
        @click="
          addressId = 0;
          addAddress({});
        "
        >添加地址</a-button
      >
    </div>
    <a-divider />
    <a-table
      class="address-table"
      bordered
      :columns="columns"
      rowKey="id"
      :pagination="false"
      :dataSource="addressData"
    >
      <!-- <template slot="regionId" slot-scope="text">
        <span>{{getAddressesDetail(text)}}</span>
      </template>-->
      <template slot="action" slot-scope="text, record">
        <a
          @click="
            addressId = record.id;
            addAddress(record);
          "
          >编辑</a
        >
        <a-divider type="vertical" />
        <a-popconfirm
          title="您确定删除该条收货地址信息吗？"
          @confirm="delAddr(record.id)"
          okText="确定"
          cancelText="取消"
        >
          <a>删除</a>
        </a-popconfirm>
      </template>
      <template
        slot="defAdr"
        slot-scope="text, record"
        style="text-align: center"
      >
        <a-tag v-if="text" color="#e69b47">默认地址</a-tag>
        <a-button v-else @click="setDef(record.id)">设置为默认地址</a-button>
      </template>
    </a-table>
    <!-- 新增地址 -->
    <a-modal
      :title="addressId === 0 ? '修改地址' : '新增地址'"
      :visible="addressModal"
      :confirmLoading="confirmLoading"
      :maskClosable="false"
      @cancel="addressModal = false"
    >
      <a-form :form="addressForm">
        <a-form-item
          label="地址信息"
          :label-col="{ span: 5 }"
          :wrapper-col="{ span: 17 }"
        >
          <!-- <a-cascader
            v-decorator="[{ rules: [{ required: true, message: '请输入地址' }] }]"
            :options="options"
            @change="onChange"
            placeholder="选择地区"
          />-->
          <expertAddress @addressChange="addressChange" />
        </a-form-item>
        <a-form-item
          label="详细地址"
          :label-col="{ span: 5 }"
          :wrapper-col="{ span: 17 }"
        >
          <a-textarea
            v-decorator="[
              'detail',
              {
                rules: [{ required: true, message: '请输入详细地址。' }],
                initialValue: addressDetail.detail
              }
            ]"
            :rows="3"
            placeholder="请输入详细地址信息，如道路、门牌号、小区、楼栋号、单元号等信息"
          ></a-textarea>
        </a-form-item>
        <a-form-item
          label="邮政编码"
          :label-col="{ span: 5 }"
          :wrapper-col="{ span: 17 }"
        >
          <a-input
            placeholder="请输入邮政编码"
            v-decorator="['zip', { initialValue: addressDetail.zip }]"
          />
        </a-form-item>
        <a-form-item
          label="收货人姓名"
          :label-col="{ span: 5 }"
          :wrapper-col="{ span: 17 }"
        >
          <a-input
            v-decorator="[
              'name',
              {
                rules: [{ required: true, message: '长度不能超过25个字符' }],
                initialValue: addressDetail.name
              }
            ]"
            placeholder="长度不能超过25个字符"
          />
        </a-form-item>
        <a-form-item
          label="手机号码"
          :label-col="{ span: 5 }"
          :wrapper-col="{ span: 17 }"
        >
          <a-input
            v-decorator="[
              'phone',
              {
                rules: [
                  { required: true, message: '电话号码、手机号码必须填一项' }
                ],
                initialValue: addressDetail.phone
              }
            ]"
            placeholder="电话号码、手机号码必须填一项"
          />
        </a-form-item>
        <a-form-item>
          <a-checkbox :checked="defAdr" @change="defAdrChange"
            >设置为默认收货地址</a-checkbox
          >
        </a-form-item>
      </a-form>
      <div slot="footer">
        <a-button class="mr20" type="primary" @click="saveAddress"
          >保存</a-button
        >
        <a-button @click="addressModal = false">取消</a-button>
      </div>
    </a-modal>
    <!-- 修改密码 -->
    <a-modal
      :title="step === 1 ? '修改密码' : '重新设置密码'"
      :visible="passwordModal"
      :footer="false"
      :maskClosable="false"
      :confirmLoading="confirmLoading"
      @cancel="
        passwordModal = false;
        step = 1;
      "
      :closable="false"
    >
      <div>
        <a-form :form="passwordForm">
          <!-- <a-form-item label="账号" :label-col="{ span: 5 }" :wrapper-col="{ span: 17 }">
            <a-input
              v-decorator="['phone', { rules: [{ required: true, message: '请输入账号' }] }]"
              placeholder="请输入账号"
            />
          </a-form-item>-->
          <a-form-item
            label="旧密码"
            :label-col="{ span: 5 }"
            :wrapper-col="{ span: 17 }"
          >
            <a-input
              type="password"
              v-decorator="[
                'oldPwd',
                { rules: [{ required: true, message: '请输入旧密码' }] }
              ]"
              placeholder="初始密码为：123456"
            />
          </a-form-item>
          <a-form-item
            label="新密码"
            :label-col="{ span: 5 }"
            :wrapper-col="{ span: 17 }"
          >
            <a-input
              type="password"
              v-decorator="[
                'newPwd',
                { rules: [{ required: true, message: '请输入新密码' }] }
              ]"
              placeholder="请输入新密码"
            />
            <div>密码为6-16位字符，包含数字和字母。</div>
          </a-form-item>
          <a-form-item
            label="确认新密码"
            :label-col="{ span: 5 }"
            :wrapper-col="{ span: 17 }"
          >
            <a-input
              type="password"
              v-decorator="[
                'passwordRepeat',
                {
                  rules: [
                    { min: 6, message: '最小长度为6' },
                    { required: true, message: '请重复新密码' },
                    { validator: validatePassword }
                  ]
                }
              ]"
              placeholder="请输入新密码"
            />
          </a-form-item>
          <!-- <span style="color: red;">密码错误</span> -->
          <!-- <router-link style="float: right;" to>忘记密码</router-link> -->
        </a-form>
        <div style="text-align: center;">
          <a-button type="primary" @click="updatePwd">确认修改</a-button>
          <!-- <a-button class="ml10" @click="passwordModal">取消</a-button> -->
          <!-- <a-button type="primary" class="next" @click="next">下一步</a-button> -->
        </div>
      </div>
      <!-- <div v-show="step === 2">
        <a-form :form="setPwdForm">
          <a-form-item label="新密码" :label-col="{ span: 5 }" :wrapper-col="{ span: 17 }">
            <a-input
              type="password"
              v-decorator="['password', { rules: [{ required: true, message: '请输入新密码' }] }]"
              placeholder="请输入新密码"
            />
            <div>密码为6-16位字符，包含数字和字母。</div>
          </a-form-item>
          <a-form-item label="确认新密码" :label-col="{ span: 5 }" :wrapper-col="{ span: 17 }">
            <a-input
              type="password"
              v-decorator="['passwordRepeat',{rules: [{min: 6, message: '最小长度为6'}, { required: true, message: '请重复新密码' }, { validator: validatePassword }]}]"
              placeholder="请输入新密码"
            />
          </a-form-item>
        </a-form>
        <div style="text-align: center;">
          <a-button type="primary" @click="updatePwd">确认修改</a-button>
          <a-button class="ml10" @click="passwordModal">取消</a-button>
        </div>
      </div>-->
    </a-modal>
    <!-- 修改手机号 -->
    <a-modal
      title="修改手机号"
      :visible="phoneModal"
      :confirmLoading="confirmLoading"
      :maskClosable="false"
      @cancel="phoneModal = false"
    >
      <h3>我们不会泄露您的手机信息!</h3>
      <a-form :form="phoneForm">
        <a-form-item
          label="手机号码"
          :label-col="{ span: 5 }"
          :wrapper-col="{ span: 17 }"
        >
          <a-input
            v-decorator="['phone', { rules: [{ validator: validateMobile }] }]"
            placeholder="请输入手机号码"
          />
        </a-form-item>
        <a-form-item
          label="校验码"
          :label-col="{ span: 5 }"
          :wrapper-col="{ span: 17 }"
        >
          <a-input-search
            placeholder="请填写短信验证码"
            @search="handleGetMessage"
            :style="{ 'max-width': '400px' }"
            v-decorator="[
              'message',
              {
                rules: [
                  { len: 6, message: '请输入正确的短信验证码' },
                  { required: true, message: '请填写短信验证码' }
                ]
              }
            ]"
          >
            <a-button
              type="primary"
              slot="enterButton"
              :disabled="mobileSecond > 0"
              >{{
                mobileSecond > 0 ? mobileSecond + "s" : "获取短信"
              }}</a-button
            >
          </a-input-search>
        </a-form-item>
      </a-form>
      <div slot="footer">
        <a-button class="mr20" type="primary" @click="updatePhone"
          >确定</a-button
        >
        <a-button @click="phoneModal = false">取消</a-button>
      </div>
      <a-alert type="warning" message="没有收到短信验证码？">
        <div slot="description">
          <p>1.手机验证码存在延时，可能需要2~3分钟才能收到，请稍后再试哦。</p>
          <p>
            2.如2~3分钟后，认为收到，请检查您的手机是否已经停止服务，或拦截了我们的短信，或收件箱已满。
          </p>
          <p>
            3.您可以尝试将SIM卡移动到另一部手机，然后重试，或者联系手机运营商咨询。
          </p>
          <p>4.当手机丢失，停用或不在身边时，建议你鞥更换其他验证方式。</p>
        </div>
      </a-alert>
    </a-modal>
  </div>
</template>

<script>
import { validateMobile } from "@/utils/validator";
import { authInfo, modifyPwd, modifyHeadPic } from "@/serve/auth";
import {
  getAddresses,
  modifyAddress,
  addAddress,
  modifyAddressDef,
  deleteAddress
} from "@/serve/addresses";
import { regionsDetail } from "@/serve/regions";
import global from "global";
import md5 from "md5";
import expertAddress from "@/components/expertAddress";
export default {
  name: "personCenter",
  components: {
    expertAddress
  },
  data() {
    return {
      id: this.$route.params.id,
      addressForm: this.$form.createForm(this),
      passwordForm: this.$form.createForm(this),
      // setPwdForm: this.$form.createForm(this),
      phoneForm: this.$form.createForm(this),
      previewVisible: false,
      confirmLoading: false,
      previewImage: "",
      fileList: [],
      addressModal: false,
      passwordModal: false,
      phoneModal: false,
      addressId: "", // 收货地址id
      step: 1,
      validateMobile,
      mobileSecond: 0,
      validatePassword: (rule, value, callback) => {
        if (!value) {
          callback(new Error("重复密码不能为空"));
        } else {
          if (this.passwordForm.getFieldValue("newPwd") === value) {
            callback();
          } else {
            callback(new Error("密码输入不一致"));
          }
        }
      },
      personInfo: {},
      columns: [
        {
          title: "收货人",
          key: "name",
          dataIndex: "name",
          scopedSlots: { customRender: "name" }
        },
        {
          title: "所在地区",
          key: "addDetail",
          dataIndex: "addDetail",
          scopedSlots: { customRender: "addDetail" }
        },
        {
          title: "详细地址",
          key: "detail",
          dataIndex: "detail",
          scopedSlots: { customRender: "detail" }
        },
        {
          title: "邮编",
          key: "zip",
          dataIndex: "zip",
          scopedSlots: { customRender: "zip" }
        },
        {
          title: "电话/手机",
          key: "phone",
          dataIndex: "phone",
          scopedSlots: { customRender: "phone" }
        },
        {
          title: "操作",
          key: "action",
          dataIndex: "action",
          scopedSlots: { customRender: "action" }
        },
        {
          title: "设置默认地址",
          key: "defAdr",
          dataIndex: "defAdr",
          scopedSlots: { customRender: "defAdr" }
        }
      ],
      addressData: [],
      options: [
        {
          value: "zhejiang",
          label: "Zhejiang",
          children: [
            {
              value: "hangzhou",
              label: "Hangzhou",
              children: [
                {
                  value: "xihu",
                  label: "West Lake"
                }
              ]
            }
          ]
        },
        {
          value: "jiangsu",
          label: "Jiangsu",
          children: [
            {
              value: "nanjing",
              label: "Nanjing",
              children: [
                {
                  value: "zhonghuamen",
                  label: "Zhong Hua Men"
                }
              ]
            }
          ]
        }
      ],
      add: [],
      state: this.$route.query.state, // 是否是初始化密码
      addressDetail: {},
      regionId: "",
      defAdr: false
    };
  },
  methods: {
    getPhoto(pic) {
      return global.file.url + "/sys/fs/" + pic + "?s=2";
    },
    handleCancel() {
      this.previewVisible = false;
    },
    handlePreview(file) {
      this.previewImage = file.url || file.thumbUrl;
      this.previewVisible = true;
    },
    // 修改头像
    handleChange({ fileList }) {
      this.fileList = fileList;
      let params = {
        headPic: this.fileList[0].response.id
      };
      modifyHeadPic(params)
        .then(() => {
          this.$message.success("头像修改成功");
          this.init();
        })
        .catch(err => {
          this.$message.error(err.data.message || "操作失败，请稍后重试");
        });
    },
    addAddress(val) {
      this.addressDetail = val;
      this.defAdr = val.defAdr;
      this.addressModal = true;
    },
    defAdrChange(val) {
      this.defAdr = val.target.checked;
    },
    addressChange(list) {
      this.regionId = list[list.length - 1].value;
    },
    setDef(id) {
      modifyAddressDef(id)
        .then(() => {
          this.$message.success("设置成功");
          this.init();
        })
        .catch(err => {
          this.$message.error(err.data.message || "操作失败，请稍后再试");
        });
    },
    // 删除收货地址
    delAddr(id) {
      deleteAddress(id)
        .then(res => {
          this.$message.success("删除成功");
          this.getAddresses();
        })
        .catch(err => {
          this.$message.error(err.data.message || "删除失败");
        });
    },
    // 保存地址
    saveAddress(e) {
      e.preventDefault();
      this.addressForm.validateFields((err, values) => {
        if (!err) {
          values.regionId = this.regionId;
          values.defAdr = this.defAdr;
          values.email = "";
          if (this.addressId === 0) {
            addAddress(values)
              .then(res => {
                this.$message.success("新增地址成功");
                this.init();
              })
              .catch(err => {
                this.$message.error(err.data.message || "操作失败，请稍后再试");
              });
          } else {
            modifyAddress(this.addressId, values)
              .then(res => {
                this.$message.success("修改地址成功");
                this.init();
              })
              .catch(err => {
                this.$message.error(err.data.message || "操作失败，请稍后再试");
              });
          }
          this.addressModal = false;
        }
      });
    },
    // 修改密码下一步
    next() {
      this.step = 2;
    },
    // 确认修改密码
    updatePwd(e) {
      e.preventDefault();
      this.passwordForm.validateFields((err, values) => {
        if (!err) {
          values.oldPwd = md5(values.oldPwd);
          values.newPwd = md5(values.newPwd);
          modifyPwd(values)
            .then(res => {
              this.$message.success("密码修改成功");
              this.$router.push({
                path: `/personCenter/${this.personInfo.id}?state=${this.personInfo.state}`
              });
            })
            .catch(err => {
              this.$message.error(
                err.data.message || "密码修改失败，请稍后再试"
              );
            });
        }
      });
      this.passwordModal = false;
    },
    // 获取短信验证码
    handleGetMessage() {
      this.setCountDown();
    },
    // 60秒倒计时
    setCountDown() {
      this.mobileSecond = 60;
      var countDownLoop = () => {
        setTimeout(() => {
          this.mobileSecond--;
          if (this.mobileSecond > 0) {
            countDownLoop();
          } else {
            clearTimeout(countDownLoop);
          }
        }, 1000);
      };
      countDownLoop();
    },
    // 确认更换手机
    updatePhone() {
      this.phoneModal = false;
    },
    getAdd(aa) {
      this.add.push(aa.name);
      if (aa.parentRegion) {
        this.getAdd(aa.parentRegion);
      }
      let temp = this.add.reverse();
      return temp.join("");
    },
    // 获取地址详情
    async getAddressesDetail(id) {
      let asd = "";
      await regionsDetail(id).then(res => {
        this.add = [];
        asd = this.getAdd(res);
      });
      return asd;
    },
    // 初始化信息
    init() {
      // 获取用户信息
      authInfo().then(res => {
        this.fileList = [];
        if (res.headPic) {
          this.fileList.push({
            uid: -1,
            name: "photo.jpg",
            status: "done",
            url: this.getPhoto(res.headPic)
          });
        }
        this.personInfo = res;
      });
      this.getAddresses();
    },
    getAddresses() {
      // 获取收货地址
      getAddresses().then(res1 => {
        for (let i = 0; i < res1.length; i++) {
          this.getAddressesDetail(res1[i].regionId).then(res => {
            this.$set(res1[i], "addDetail", res);
          });
        }
        this.addressData = res1;
      });
    }
  },
  created() {
    this.init();
    if (this.state === "INIT") {
      this.passwordModal = true;
    }
  }
};
</script>

<style lang="less">
.person-center {
  width: 1200px;
  margin: 0 auto;
  box-shadow: 0px 0px 5px #ccc;
  h3 {
    line-height: 40px;
    padding: 0 20px;
    font-size: 18px;
  }
  .ant-divider-horizontal {
    margin: 0;
  }
  .person-info {
    display: flex;
    padding: 20px;
    .ant-upload-list-picture-card-container,
    .ant-upload.ant-upload-select-picture-card,
    .ant-upload-list-picture-card .ant-upload-list-item {
      width: 160px;
      height: 160px;
    }
    .person-detail {
      margin-left: 20px;
      span {
        color: #e69b47;
        cursor: pointer;
      }
    }
  }
  .person-address {
    display: flex;
    justify-content: space-between;
    padding: 10px;
  }
  .address-table {
    padding: 20px 20px 30px 20px;
  }
}
.next {
  // background: rgba(95, 205, 151, 1);
  // color: #fff;
  width: 80%;
  margin-left: 10%;
  margin-top: 20px;
}
.ant-btn:hover {
  // background: rgba(95, 205, 151, 1);
  // color: #fff;
}
</style>
